export default __webpack_public_path__ + "img/tiktok_hover.4eab0cfbc56838562d0c616ae056c2d2.svg";